/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineTimeZoneInfoDto } from './traveline-time-zone-info-dto';
import {
    TravelineTimeZoneInfoDtoFromJSON,
    TravelineTimeZoneInfoDtoFromJSONTyped,
    TravelineTimeZoneInfoDtoToJSON,
    TravelineTimeZoneInfoDtoToJSONTyped,
} from './traveline-time-zone-info-dto';
import type { TravelineRatePlanInfoDto } from './traveline-rate-plan-info-dto';
import {
    TravelineRatePlanInfoDtoFromJSON,
    TravelineRatePlanInfoDtoFromJSONTyped,
    TravelineRatePlanInfoDtoToJSON,
    TravelineRatePlanInfoDtoToJSONTyped,
} from './traveline-rate-plan-info-dto';
import type { TravelineContactInfoDto } from './traveline-contact-info-dto';
import {
    TravelineContactInfoDtoFromJSON,
    TravelineContactInfoDtoFromJSONTyped,
    TravelineContactInfoDtoToJSON,
    TravelineContactInfoDtoToJSONTyped,
} from './traveline-contact-info-dto';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';
import type { TravelinePolicyInfoDto } from './traveline-policy-info-dto';
import {
    TravelinePolicyInfoDtoFromJSON,
    TravelinePolicyInfoDtoFromJSONTyped,
    TravelinePolicyInfoDtoToJSON,
    TravelinePolicyInfoDtoToJSONTyped,
} from './traveline-policy-info-dto';
import type { TravelineServiceInfoDto } from './traveline-service-info-dto';
import {
    TravelineServiceInfoDtoFromJSON,
    TravelineServiceInfoDtoFromJSONTyped,
    TravelineServiceInfoDtoToJSON,
    TravelineServiceInfoDtoToJSONTyped,
} from './traveline-service-info-dto';
import type { TravelineStayUnitKindDto } from './traveline-stay-unit-kind-dto';
import {
    TravelineStayUnitKindDtoFromJSON,
    TravelineStayUnitKindDtoFromJSONTyped,
    TravelineStayUnitKindDtoToJSON,
    TravelineStayUnitKindDtoToJSONTyped,
} from './traveline-stay-unit-kind-dto';
import type { TravelineRoomTypeInfoDto } from './traveline-room-type-info-dto';
import {
    TravelineRoomTypeInfoDtoFromJSON,
    TravelineRoomTypeInfoDtoFromJSONTyped,
    TravelineRoomTypeInfoDtoToJSON,
    TravelineRoomTypeInfoDtoToJSONTyped,
} from './traveline-room-type-info-dto';

/**
 * Information on the accommodation property<br />
 * The Id field is always filled in, other fields - in case of parameter ‘include=all’
 * @export
 * @interface TravelinePropertyInfoDto
 */
export interface TravelinePropertyInfoDto {
    /**
     * Property ID
     * @type {string}
     * @memberof TravelinePropertyInfoDto
     */
    propertyId?: string;
    /**
     * Property ID
     * @type {string}
     * @memberof TravelinePropertyInfoDto
     */
    id: string;
    /**
     * Property name
     * @type {string}
     * @memberof TravelinePropertyInfoDto
     */
    name: string | null;
    /**
     * Detailed description of the property
     * @type {string}
     * @memberof TravelinePropertyInfoDto
     */
    description?: string | null;
    /**
     * Property photo gallery
     * @type {Array<TravelineResourceDto>}
     * @memberof TravelinePropertyInfoDto
     */
    images: Array<TravelineResourceDto> | null;
    /**
     * Star rating of the property
     * @type {number}
     * @memberof TravelinePropertyInfoDto
     */
    stars?: number | null;
    /**
     * 
     * @type {TravelineStayUnitKindDto}
     * @memberof TravelinePropertyInfoDto
     */
    stayUnitKind?: TravelineStayUnitKindDto;
    /**
     * 
     * @type {TravelineContactInfoDto}
     * @memberof TravelinePropertyInfoDto
     */
    contactInfo?: TravelineContactInfoDto;
    /**
     * 
     * @type {TravelinePolicyInfoDto}
     * @memberof TravelinePropertyInfoDto
     */
    policy?: TravelinePolicyInfoDto;
    /**
     * 
     * @type {TravelineTimeZoneInfoDto}
     * @memberof TravelinePropertyInfoDto
     */
    timeZone?: TravelineTimeZoneInfoDto;
    /**
     * Property rate plans
     * @type {Array<TravelineRatePlanInfoDto>}
     * @memberof TravelinePropertyInfoDto
     */
    ratePlans?: Array<TravelineRatePlanInfoDto> | null;
    /**
     * Room types of the property
     * @type {Array<TravelineRoomTypeInfoDto>}
     * @memberof TravelinePropertyInfoDto
     */
    roomTypes?: Array<TravelineRoomTypeInfoDto> | null;
    /**
     * List of services provided by the property
     * @type {Array<TravelineServiceInfoDto>}
     * @memberof TravelinePropertyInfoDto
     */
    services?: Array<TravelineServiceInfoDto> | null;
    /**
     * The property types are apartments or flats, which may be located at different addresses
     * @type {boolean}
     * @memberof TravelinePropertyInfoDto
     */
    multiLocationProperty?: boolean | null;
}



/**
 * Check if a given object implements the TravelinePropertyInfoDto interface.
 */
export function instanceOfTravelinePropertyInfoDto(value: object): value is TravelinePropertyInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    return true;
}

export function TravelinePropertyInfoDtoFromJSON(json: any): TravelinePropertyInfoDto {
    return TravelinePropertyInfoDtoFromJSONTyped(json, false);
}

export function TravelinePropertyInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePropertyInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'images': (json['images'] == null ? null : (json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'stars': json['stars'] == null ? undefined : json['stars'],
        'stayUnitKind': json['stayUnitKind'] == null ? undefined : TravelineStayUnitKindDtoFromJSON(json['stayUnitKind']),
        'contactInfo': json['contactInfo'] == null ? undefined : TravelineContactInfoDtoFromJSON(json['contactInfo']),
        'policy': json['policy'] == null ? undefined : TravelinePolicyInfoDtoFromJSON(json['policy']),
        'timeZone': json['timeZone'] == null ? undefined : TravelineTimeZoneInfoDtoFromJSON(json['timeZone']),
        'ratePlans': json['ratePlans'] == null ? undefined : ((json['ratePlans'] as Array<any>).map(TravelineRatePlanInfoDtoFromJSON)),
        'roomTypes': json['roomTypes'] == null ? undefined : ((json['roomTypes'] as Array<any>).map(TravelineRoomTypeInfoDtoFromJSON)),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(TravelineServiceInfoDtoFromJSON)),
        'multiLocationProperty': json['multiLocationProperty'] == null ? undefined : json['multiLocationProperty'],
    };
}

  export function TravelinePropertyInfoDtoToJSON(json: any): TravelinePropertyInfoDto {
      return TravelinePropertyInfoDtoToJSONTyped(json, false);
  }

  export function TravelinePropertyInfoDtoToJSONTyped(value?: TravelinePropertyInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'images': (value['images'] == null ? null : (value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'stars': value['stars'],
        'stayUnitKind': TravelineStayUnitKindDtoToJSON(value['stayUnitKind']),
        'contactInfo': TravelineContactInfoDtoToJSON(value['contactInfo']),
        'policy': TravelinePolicyInfoDtoToJSON(value['policy']),
        'timeZone': TravelineTimeZoneInfoDtoToJSON(value['timeZone']),
        'ratePlans': value['ratePlans'] == null ? undefined : ((value['ratePlans'] as Array<any>).map(TravelineRatePlanInfoDtoToJSON)),
        'roomTypes': value['roomTypes'] == null ? undefined : ((value['roomTypes'] as Array<any>).map(TravelineRoomTypeInfoDtoToJSON)),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(TravelineServiceInfoDtoToJSON)),
        'multiLocationProperty': value['multiLocationProperty'],
    };
}

